export default __webpack_public_path__ + "static/media/featured-in-1.4436bc51.png";